import styled from 'styled-components';

interface FormGroupProps {
  fullWidth?: boolean;
}

// export const ModalOverlay = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   background-color: rgba(0, 0, 0, 0.5);
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   z-index: 1000;
// `;

// export const ModalContainer = styled.div`
//   background-color: white;
//   width: 100%;
//   max-width: 500px;
//   padding: 40px;
// `;

// export const ModalContent = styled.div`
//   background-color: #F3F4F6;
//   border-radius: 8px;
//   padding: 32px;
//   border: 1px solid #dee2e6;
// `;

// export const ModalHeader = styled.div`
//   margin-bottom: 24px;
  
//   h2 {
//     margin: 0;
//     color: #0066FF;
//     font-size: 1.25rem;
//     font-weight: 500;
//   }
// `;

// export const ModalBody = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 16px;
// `;

export const FormGroup = styled.div<FormGroupProps>`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  color: #495057;
  font-size: 0.875rem;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 0.875rem;
  background-color: white;
  
  &::placeholder {
    color: #adb5bd;
  }
  
  &:focus {
    outline: none;
    border-color: #0066FF;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 24px;
`;

export const Button = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 0.875rem;
  cursor: pointer;
  border: 1px solid transparent;
  
  &.primary {
    background-color: #0066FF;
    color: white;
    
    &:hover {
      background-color: #0052cc;
    }

    &:disabled {
      background-color: #99c2ff;
      cursor: not-allowed;
    }
  }
  
  &.secondary {
    background-color: transparent;
    color: #0066FF;
    border-color: #0066FF;
    
    &:hover {
      background-color: #f8f9fa;
    }
  }
`;

export const ErrorMessage = styled.span`
  color: #dc3545;
  font-size: 0.75rem;
  margin-top: 4px;
`;
